<div class="modal-body">
  <div class="invisible-input">
    <input ngbAutofocus />
  </div>
  <div class="close-button">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <h2 class="h2" i18n>What type of chart do you want to make?</h2>
  <div class="row chart-types">
    <div class="col">
      <ng-container *ngIf="quantityChartTemplatesExist; else noQuantityChartTemplates">
        <div data-cy="chart-quantity-icon" class="chart-icon" (click)="createChart(chartTypes.Quantity)">
          <img src="/assets/images/analytics/quantity-chart.svg" />
          <div *ngIf="showSpinner && selectedKind === chartTypes.Quantity; then loadingSpinner"></div>
        </div>
        <div class="chart-type-name" i18n>Quantity</div>
        <div class="chart-type-description" i18n>Track quantities in your forms</div>
      </ng-container>
      <ng-template #noQuantityChartTemplates>
        <div data-cy="chart-quantity-icon" class="chart-icon chart-inactive">
          <img src="/assets/images/analytics/quantity-chart-inactive.svg" />
        </div>
        <div class="chart-type-name" i18n>Quantity</div>
        <div class="chart-type-description" i18n>Track quantities in your forms</div>
        <div class="chart-extra-info">
          You need a template with tables <br />
          to use this chart
          <a href="https://intercom.help/dashpivot/en/articles/4681587-quantity-charts" target="_blank"
            >(Learn how)</a
          >
        </div>
      </ng-template>
    </div>
    <div class="col">
      <div data-cy="chart-frequency-icon" class="chart-icon" (click)="createChart(chartTypes.Frequency)">
        <img src="/assets/images/analytics/frequency-chart.svg" />
        <div *ngIf="showSpinner && selectedKind === chartTypes.Frequency; then loadingSpinner"></div>
      </div>
      <div class="chart-type-name" i18n>Frequency</div>
      <div class="chart-type-description" i18n>Track forms created over time</div>
    </div>
    <div class="col">
      <div data-cy="chart-ratio-icon" class="chart-icon" (click)="createChart(chartTypes.Ratio)">
        <img src="/assets/images/analytics/ratio-chart.svg" alt="" />
        <div *ngIf="showSpinner && selectedKind === chartTypes.Ratio; then loadingSpinner"></div>
      </div>
      <div class="chart-type-name" i18n>Ratio</div>
      <div class="chart-type-description" i18n>Compare groups of forms</div>
    </div>
  </div>

  <div class="row">
    <div class="text-center col">
      <a
        href="https://intercom.help/dashpivot/en/articles/2563238-analytics"
        target="_blank"
        class="btn cc-btn-subtle-outlined learn-more-button"
      >
        <i class="cc-icon cc-icon-help"></i>
        <span i18n>Not sure? Learn more about charts</span>
      </a>
    </div>
  </div>
</div>

<ng-template #loadingSpinner>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>
